import React from "react";
import { connect } from 'dva';
import { Descriptions } from 'antd';
import { framework_tool, component_tool, utils_tool } from '@/tool'
import createColumns from './columns'

let { WizContainer, modelUtils } = framework_tool
let { WizCard, WizSpin, WizButton, WizSearchBar, WizDataTable, WizBrowserExport, WizTabs, } = component_tool
let { Session, getPageData } = utils_tool

class ApplicationColumnRecord extends WizContainer {
  componentName = 'applicationColumnRecord'

  constructor(props) {
    super(props)
    const { history } = props
    let detailInfo = {};
    if (history.location && history.location.pathname === '/application/applicationColumn/applicationColumnRecord') {
      if (history.location && history.location.record) {
        detailInfo = history.location.record
        Session.set('detailInfo', detailInfo)
      } else {
        detailInfo = Session.get('detailInfo') || {}
      }
    }
    this.detailInfo = detailInfo
    this.visitFilters = {}
    this.chooseFilters = {}
    this.visitNum = undefined
    this.chooseNum = undefined
    this.state = {
      columnId: detailInfo.id,
      visitNum: 0,
      chooseNum: 0
    }
  }

  _componentDidMount() {
    this._getVisitList();
    this._getChooseList();
  }

  propsAndStateOnChange = {
    visitListExport: this._visitListExportOver.bind(this),
    chooseListExport: this._chooseListExportOver.bind(this),
    visitPageList: this._visitPageList.bind(this),
    choosePageList: this._choosePageList.bind(this)
  }

  _visitPageList(nextProps, nextState) {
    let { visitPageList } = nextProps
    if (visitPageList['success']) {
      nextState['visitNum'] = visitPageList['data']['total'] || 0
      return true;
    } else {
      wizNotice.error(visitPageList['msg'] || '获取数据失败，请稍后再试')
    }
    return false
  }

  _choosePageList(nextProps, nextState) {
    let { choosePageList } = nextProps
    if (choosePageList['success']) {
      nextState['chooseNum'] = choosePageList['data']['total'] || 0
      return true;
    } else {
      wizNotice.error(choosePageList['msg'] || '获取数据失败，请稍后再试')
    }
    return false
  }

  /**导出访问记录*/
  _visitListExportOver(nextProps, nextState) {
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
        }
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '任职',
        field: 'userIdentityInfos',
        width: 40,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '访问时间',
        field: 'createTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '离开时间',
        field: 'quitTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '访问终端类型',
        field: 'adapter',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]
    if (nextProps.visitListExport.code === 1) {
      let adapterEnum = {0: 'PC', 1: 'APP', 4: '企业微信'}
      let data = nextProps.visitListExport.data
      data && data.forEach(e => {
        e['adapter'] = adapterEnum[e['adapter']]
      })
      WizBrowserExport({
        title: '访问记录信息',
        sheetName: '访问记录信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '访问记录信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error('获取导出数据失败')
      return false;
    }
  }

  /**导出选择记录*/
  _chooseListExportOver(nextProps, nextState) {
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
        }
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '任职',
        field: 'userIdentityInfos',
        width: 40,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '选择时间',
        field: 'updateTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '状态',
        field: 'status',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]
    if (nextProps.chooseListExport.code === 1) {
      let data = nextProps.chooseListExport.data
      data && data.forEach(e => {
        e['status'] == 0 ? e['status'] = "无效" : e['status'] = "有效"
      })
      WizBrowserExport({
        title: '选择记录信息',
        sheetName: '选择记录信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '选择记录信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error('获取导出数据失败')
      return false;
    }
  }

  changeTab = (e) => {
    if (e === '1') {
      this._getVisitList()
    } else if (e === '2') {
      this._getChooseList()
    }
  }

  _getVisitList(apiParams = {}) {
    let { columnId } = this.state
    this.doAction({
      path: 'applicationColumn/visitList',
      payload: {
        key: 'applicationColumn@visitPageList',
        apiParams: {
          columnId: columnId,
          ...apiParams
        }
      }
    })
  }

  _getVisitInfo(apiParams = {}) {
    let { columnId } = this.state
    this.doAction({
      path: 'applicationColumn/visitExport',
      payload: {
        key: 'applicationColumn@visitList',
        apiParams: {
          columnId: columnId,
          ...apiParams
        }
      }
    })
  }

  _onSelect(keys, rows) {
    this.setState({
      keys,
      rows,
      selectedRows: keys.length
    })
  }

  _getChooseList(apiParams = {}) {
    let { columnId } = this.state
    this.doAction({
      path: 'applicationColumn/chooseList',
      payload: {
        key: 'applicationColumn@choosePageList',
        apiParams: {
          columnId: columnId,
          ...apiParams
        }
      }
    })
  }

  _getChooseInfo(apiParams = {}) {
    let { columnId } = this.state
    this.doAction({
      path: 'applicationColumn/chooseExport',
      payload: {
        key: 'applicationColumn@chooseList',
        apiParams: {
          columnId: columnId,
          ...apiParams
        }
      }
    })
  }

  /**
   * 渲染操作按钮 且 进行权限检查
   */
  _renderBtn = (type) => {
    let r = []
    let btns = new Map();
    btns.set('export',
      <WizButton title="导出"
                 type="export"
                 onClick={() => {
                   if (type === 'visit') {
                     this._getVisitInfo(this.visitFilters)
                   }
                   if (type === 'choose') {
                     this._getChooseInfo(this.chooseFilters)
                   }
                 }}
                 icon="export"
                 style={{marginBottom: 15}}>导出</WizButton>
    );
    let btnCode = this.getMenuBtn() || [];
    btnCode.map(({code}) => {
      if (btns.has(code)) {
        r.push(btns.get(code))
      }
    })
    return r
  }

  renderRecordInfo = (type) => {
    let { visitPageList, choosePageList, applicationColumnLoading } = this.props
    let columns = createColumns(this, type)
    let pageList = type === 'visit' ? visitPageList : choosePageList
    let list = getPageData(pageList && pageList.data)
    let searchBarProps = {
      columns,
      onSearch: values => {
        if (type === 'visit') {
          this.visitFilters = values
          this._getVisitList(values)
        }
        if (type === 'choose') {
          this.chooseFilters = values
          this._getChooseList(values)
        }
      }
    }
    let dataTableProps = {
      loading: applicationColumnLoading,
      columns,
      rowKey: 'id',
      dataItems: list,
      isScroll: true,
      onChange: ({ pageNum, pageSize }) => {
        if (type === 'visit') {
          this._getVisitList({ current: pageNum, size: pageSize, ...this.visitFilters })
        }
        if (type === 'choose') {
          this._getChooseList({ current: pageNum, size: pageSize, ...this.chooseFilters })
        }
      },
      onSelect: (keys, rows) => this._onSelect(keys, rows)
    }
    return (
      <WizSpin tip={'加载中'} spinning={applicationColumnLoading}>
        <div className='pagination'>
          <WizSearchBar key="applicationColumn_searchBar" type="grid" {...searchBarProps} />
        </div>
        {this._renderBtn(type)}
        <WizDataTable key={'applicationColumn_dataTable'} {...dataTableProps} />
        <div className='pagination'>
          <WizDataTable.Pagination key={'applicationColumn_pagination'} {...dataTableProps} />
        </div>
      </WizSpin>
    )
  }

  _render() {
    const items = this.detailInfo
    items['type'] == 0 ? items['type'] = "独立应用" : items['type'] == 1 ? items['type'] = "内嵌应用" : "外链"

    return (
      <React.Fragment>
        <WizCard title={'基础信息'}>
          <Descriptions column={2} style={{ paddingLeft: 25 }}>
            <Descriptions.Item label='栏目应用'>{items.name}</Descriptions.Item>
            <Descriptions.Item label='分类'>{items.categoryName}</Descriptions.Item>
            <Descriptions.Item label='类型'>{items.type}</Descriptions.Item>
            <Descriptions.Item label='适用终端'>{items.adapterNames}</Descriptions.Item>
          </Descriptions>
        </WizCard>

        <WizCard title="记录管理">
          <WizTabs defaultActiveKey="1" onChange={this.changeTab}>
            <WizTabs.TabPane tab={'访问记录(' + (this.state.visitNum || 0) + ')'} key="1">
              {this.renderRecordInfo('visit')}
            </WizTabs.TabPane>
            <WizTabs.TabPane tab={'选择记录(' + (this.state.chooseNum || 0) + ')'} key="2">
              {this.renderRecordInfo('choose')}
            </WizTabs.TabPane>
          </WizTabs>
        </WizCard>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  let { applicationColumn } = state
  const visitPageList = modelUtils.getModelEntity(applicationColumn, 'applicationColumn@visitPageList');
  const choosePageList = modelUtils.getModelEntity(applicationColumn, 'applicationColumn@choosePageList');
  const visitListExport = modelUtils.getModelEntity(applicationColumn, 'applicationColumn@visitList');
  const chooseListExport = modelUtils.getModelEntity(applicationColumn, 'applicationColumn@chooseList');
  const load = modelUtils.getLoadingState(state, 'applicationColumn')
  return {
    visitPageList,
    visitListExport,
    choosePageList,
    chooseListExport,
    ...load
  }
};

export default connect(mapStateToProps)(ApplicationColumnRecord)

